module.exports = __webpack_public_path__ + "static/pup-a0d590aa6e20bd9fa2d65874e03a5d1d.png";